import axios from "axios";

import tokenService from "./tokenService";
import { SinglePoll, SingleOption, Option } from "./interfaces";

const url = "https://apiglosowanietest.polskieradio.pl";
const API = {
    ////////////////////USER
    logIn: (login: string, password: string, remember: boolean) => {
        return (
            axios.post(`${url}/api/User/Login`, {
                "login": login,
                "password": password,
                "rememberMe": remember
            })
        );
    },
    logOut: async () => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/User/Logout`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                })
            )
        }
    },
    refreshToken: (token: string, refreshToken: string) => {
        return (
            axios.post(`${url}/api/User/RefreshToken`, {
                "token": token,
                "refreshToken": refreshToken
            })
        );
    },
    ////////////////////APP
    getListOffRadioIds: async () => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/App/GetList`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            )
        }
    },
    ////////////////////CATEGORY
    getListOfCathegory: async (id: string) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Category/GetList?appId=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    getSingleCategory: async (id: string) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Category/Get?id=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            )
        }
    },


    postNewCathegory: async (name: string, appId: number, auto: boolean) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Category/Add`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "name": name,
                        "appId": appId,
                        "autoGenerateNextPoll": auto
                    }
                })
            )
        }
    },
    editCategory: async (name: string, id: number, auto: boolean | undefined, appId: number) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Category/Edit`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "name": name,
                        "autoGenerateNextPoll": auto,
                        "id": id,
                        "appId": appId
                    }
                })
            )
        }
    },
    ////////////////////SETTING
    postNewSetting: async (name: string, sms: boolean, num: number, max: number) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Setting/Add`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "name": name,
                        "isSmsVoting": sms,
                        "noOfResults": num,
                        "maxVotingTimeForAnOption": max
                    }
                })
            )
        }
    },
    getListOfSettings: async (skip = 0, size = 10) => {
        const token = await tokenService.getToken()
        if (token) {
            return (
                axios.get(`${url}/api/Setting/GetList?PageSize=${size}&Skip=${skip}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    getSingleSetting: async (id: string) => {
        const token = await tokenService.getToken()
        if (token)
            return (
                axios.get(`${url}/api/Setting/Get?id=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
    },
    removeSetting: async (id: number | boolean) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Setting/Delete`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "id": id,
                    }
                })
            )
        }
    },
    ////////////////////TAG
    postNewTag: async (name: string) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Tag/Add`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "name": name,
                    }
                })
            )
        }
    },
    getListOfTags: async (skip = 0, size = 100) => {
        const token = await tokenService.getToken()
        if (token)
            return (
                axios.get(`${url}/api/Tag/GetList?PageSize=${size}&Skip=${skip}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
    },
    removeTag: async (id: number | boolean) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Tag/Delete`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "id": id,
                    }
                })
            )
        }
    },
    ////////////////////RESULT
    getResultsList: async (cathegoryId: string, skip = 0, size = 10) => {
        const token = await tokenService.getToken()
        if (token)
            return (

                axios.get(`${url}/api/PollResult/GetList?categoryId=${cathegoryId}&PageSize=${size}&Skip=${skip}
            `), {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
    },
    getSingleResult: async (id: string) => {

        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/PollResult/Get?pollId=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            )
        }
    },
    ////////////////////POLL OPTION
    getListOfPollOptions: async (pollId: string | undefined, skip = 0, size = 50) => {
        const token = await tokenService.getToken()
        if (token) {
            return (
                axios.get(`${url}/api/PollOption/GetList?PollId=${pollId}&PageSize=${size}&Skip=${skip}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    reorderPollOptions: async (id: number, idArray: number[]) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/PollOption/Reorder`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "pollId": id,
                        "sortedOptions": idArray,
                    }
                })
            )
        }
    },
    addPollOption: async (pollId: number, optionId: number | string | undefined) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/PollOption/Add`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "pollId": pollId,
                        "optionId": optionId
                    }
                })
            )
        }
    },
    editPollOption: async (
        pollId: number,
        optionId: number,
        order: number,
        tagId: number | undefined,
        sms: string
    ) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/PollOption/Edit`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "pollId": pollId,
                        "optionId": optionId,
                        "order": order,
                        "tagId": tagId,
                        "smsCode": sms
                    }
                })
            )
        }
    },
    getPollOption: async (pollId: number, optionId: number) => {
        const token = await tokenService.getToken()
        if (token) {
            return (
                axios.get(`${url}/api/PollOption/Get?pollId=${pollId}&optionId=${optionId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    removePollOption: async (pollId: number, optionId: number) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/PollOption/Delete`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "pollId": pollId,
                        "optionId": optionId
                    }
                })
            )
        }
    },
    ////////////////////OPTION
    getListOfOptions: async (skip = 0, size = 1000) => {
        const token = await tokenService.getToken()
        if (token) {
            return (
                axios.get(`${url}/api/Option/GetList?PageSize=${size}&Skip=${skip}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    addNewOption: async (data: FormData) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Option/Add`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: data
                })
            )
        }
    },
    editOption: async (data: FormData) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Option/Edit`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: data
                })
            )
        }
    },
    ////////////////////POLL
    getListOfPolls: async (cathegoryId: string, skip = 0, size = 30) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Poll/GetList?PageSize=${size}&Skip=${skip}&categoryId=${cathegoryId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    getListOfActivePolls: async (skip = 0, size = 50) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Poll/GetActiveList?PageSize=${size}&Skip=${skip}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            );
        }
    },
    addNewPoll: async (data: SinglePoll) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Poll/Add`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: data
                })
            )
        }
    },
    getSinglePoll: async (id: string) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Poll/Get?id=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            )
        }
    },
    removePoll: async (id: number) => {
        const token = await tokenService.getToken();
        if (token) {
            axios.get(`${url}/api/Poll/Delete?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        }
    },
    editPoll: async (data: SinglePoll) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/Poll/Edit`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: data
                })
            )
        }
    },
    getVotingStats: async (id: string) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Poll/GetVotingStats?id=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            )
        }
    },
    getVotingDetails: async (id: string) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios.get(`${url}/api/Poll/GetVotingDetails?id=${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
            )
        }
    },
    ///////////////////POLL CUSTOM RESULT
    upsertCustomResult: async (pollId: number, optionId: number, noOfVotes: number) => {
        const token = await tokenService.getToken();
        if (token) {
            return (
                axios({
                    method: 'post',
                    url: `${url}/api/PollCustomResult/Upsert`,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    data: {
                        "pollId": pollId,
                        "optionId": optionId,
                        "noOfVotes": noOfVotes
                    }
                })
            )
        }
    },
}


export default API
